module.exports = __webpack_public_path__ + "img/PPMP21.e51a48a6.png";